// @ts-nocheck
/* eslint-disable */
export const arrowRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 23 22"><path d="M13.66 17.062a.66.66 0 0 1-.471-.195.67.67 0 0 1 0-.943L18.113 11 13.19 6.076a.67.67 0 0 1 0-.943.67.67 0 0 1 .942 0l5.395 5.396a.67.67 0 0 1 0 .942l-5.395 5.396a.66.66 0 0 1-.471.195"/><path d="M18.904 11.667H3.944A.67.67 0 0 1 3.278 11c0-.364.302-.666.666-.666h14.96c.365 0 .667.302.667.666a.67.67 0 0 1-.667.667"/></svg>`,
    name: 'arrow-right' as const
};